import React from 'react';
import { PictoProps } from './index';

export const Like = (props: PictoProps) => (
  <svg
    width={props.width || '24'}
    height={props.height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.284 3.49586C20.2524 2.46385 18.8531 1.88403 17.394 1.88403C15.9348 1.88403 14.5355 2.46385 13.504 3.49586L12.444 4.55586L11.384 3.49586C9.23558 1.34747 5.75235 1.34747 3.60397 3.49586C1.45558 5.64425 1.45558 9.12747 3.60397 11.2759L4.66397 12.3359L12.444 20.1159L20.224 12.3359L21.284 11.2759C22.316 10.2443 22.8958 8.845 22.8958 7.38586C22.8958 5.92672 22.316 4.52738 21.284 3.49586Z"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
